// Keep the captured pixels. Only oversized images need a lossy upload copy.
// 6 MiB leaves room for base64 in callers with a 9.5 MB request limit.
export const MAX_PHOTO_BYTES = 6 * 1024 * 1024;
export const MAX_PHOTO_PIXELS = 16 * 1024 * 1024;
export const MAX_PHOTO_SIDE = 4096;

export const photoDimensions = (width, height) => {
  if (!(width > 0 && height > 0)) throw new Error('Imagem sem dimensões.');
  const scale = Math.min(1, MAX_PHOTO_SIDE / Math.max(width, height), Math.sqrt(MAX_PHOTO_PIXELS / (width * height)));
  return { width: Math.max(1, Math.floor(width * scale)), height: Math.max(1, Math.floor(height * scale)) };
};

export const photoFits = (dataUrl) => {
  const payload = dataUrl.split(',')[1] || '';
  return payload.length > 0 && Math.ceil(payload.length * 3 / 4) <= MAX_PHOTO_BYTES;
};

export function encodePhoto(canvas) {
  const png = canvas.toDataURL('image/png');
  if (photoFits(png)) return png;
  let current = canvas;
  for (;;) {
    const jpeg = current.toDataURL('image/jpeg', 0.98);
    if (photoFits(jpeg)) return jpeg;
    if (current.width <= 1 || current.height <= 1) throw new Error('Falha ao codificar a foto.');
    const smaller = document.createElement('canvas');
    smaller.width = Math.max(1, Math.floor(current.width * 0.8));
    smaller.height = Math.max(1, Math.floor(current.height * 0.8));
    const ctx = smaller.getContext('2d');
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(canvas, 0, 0, smaller.width, smaller.height);
    current = smaller;
  }
}

export async function preparePostPhoto(input) {
  const dataUrl = typeof input === 'string' ? input : await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error('Não foi possível ler a foto.'));
    reader.readAsDataURL(input);
  });
  // The server validates and removes metadata before publishing. Do not encode
  // an already prepared camera image again on its way to quarantine.
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onerror = () => reject(new Error('Não foi possível abrir a foto.'));
    img.onload = () => {
      try {
        const dimensions = photoDimensions(img.naturalWidth, img.naturalHeight);
        if (dimensions.width === img.naturalWidth && dimensions.height === img.naturalHeight &&
            /^data:image\/(png|jpeg|webp);base64,/.test(dataUrl) && photoFits(dataUrl)) {
          resolve(dataUrl);
          return;
        }
        const canvas = document.createElement('canvas');
        Object.assign(canvas, dimensions);
        canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
        resolve(encodePhoto(canvas));
      } catch (err) { reject(err); }
    };
    img.src = dataUrl;
  });
}
